import React, { useState } from "react";
import {
  capitalize,
  dateForHumans,
  formatMoney,
  numberWithCommas,
  timeAmPm,
} from "../../utils";  
import { Breadcrumb, Descriptions, Tabs } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StatementTable from "./statement/StatementTable";
import EmtyCard from "../../components/EmtyCard";

function WalletView() {
  const { loading } = useSelector((state) => state.fetch);
  const { walletObj } = useSelector((state) => state.obj);
  const navigate = useNavigate(); 
  const items = [
    {
      key: "1",
      label: "Actual Balance",
      children: <div>{numberWithCommas(walletObj?.walActualBalance)}</div>,
    },
    {
      key: "4",
      label: "Available Balance",
      children: <div>{numberWithCommas(walletObj?.walAvailableBalance)}</div>,
    },
    {
      key: "7",
      label: "Code",
      children: walletObj?.walCode,
    },
    {
      key: "8",
      label: "Created At",
      children: <div>{dateForHumans(walletObj?.walCreatedAt)}</div>,
    },
    {
      key: "9",
      label: "Created Date",
      children: <div>{dateForHumans(walletObj?.walCreatedDate)}</div>,
    },
    {
      key: "10",
      label: "Created Time",
      children: <div>{timeAmPm(walletObj?.walCreatedTime)}</div>,
    },
    {
      key: "11",
      label: "Currency",
      children: walletObj?.walCurrency,
    },
    {
      key: "12",
      label: "Description",
      children: walletObj?.walDesc,
    },
    {
      key: "13",
      label: "Mpesa Number",
      children: walletObj?.walMpesaNumber,
    },
    {
      key: "14",
      label: "Wallet No",
      children: walletObj?.walNo,
    },
    {
      key: "15",
      label: "Status",
      children: walletObj?.walStatus,
    },
    {
      key: "16",
      label: "Type",
      children: walletObj?.walType,
    },
    {
      key: "17",
      label: "Updated Time",
      children: <div>{timeAmPm(walletObj?.walUpdatedTime)}</div>,
    },
  ];
   
  const [active, setactive] = useState("1");
  async function refetching(activeKey) {
    setactive(activeKey);
    //   await dispatch(setRefetch());
    //   await dispatch(setRefetchKey(activeKey));
  }

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Statement</span>
        </span>
      ),
      key: "1",
      children: <StatementTable />,
    },
  ];
  return (
    <div className="flex flex-col w-full h-full overflow-y-scroll">
      <div className=" font-dmSans text-[18px] mt-[1.25rem]">
        <Breadcrumb
          items={[
            {
              title: (
                <span
                  className="font-dmSans cursor-pointer "
                  onClick={() => navigate(-1)}
                >
                  My Wallets
                </span>
              ),
            },
            {
              title: (
                <span className="text-lighGold font-dmSans !text-[16px]">
                  Wallet Details
                </span>
              ),
            },
          ]}
        />
      </div>
      {Object?.keys(walletObj)?.length > 0 ? (
        <div className="w-full mt-[1.25rem] bg-[#F2F4F7] rounded-xl p-4 sm:p-6">
          <Descriptions
            colon={false}
            title="Wallet Details"
            items={items}
            column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 3,
              xl: 3,
              xxl: 3,
            }}
          />
        </div>
      ) : (
        <EmtyCard title="No  Wallet data available" />
      )}

      <div className="mt-[1.25rem] lg:px-10 px-3">
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="activity-tab-wrap activity-tab activity-bar"
        />
      </div>
    </div>
  );
}

export default WalletView;
